import { FC, useEffect } from 'react';
import { ClaimrWidgetComponent } from './claimr_widget_component';

export const ExampleApp: FC = () => {
    useEffect(() => {
        window.Telegram?.WebApp?.expand();
        window.Telegram?.WebApp?.enableClosingConfirmation();
        window.Telegram?.WebApp?.disableVerticalSwipes();
    }, []);
    return (
        <div className='page'>
            <header>
                <div className='logo'>Your app logo</div>
            </header>
            <div className='banner'>
                <div className='title'>This is a demo telegram mini app with claimr integration</div>
                <p>
                    See how easy it is to add Claimr to your telegram mini app. A simple example of real
                    integration.
                </p>
                <menu>
                    <a
                        className={'button'}
                        href='https://claimr-io.gitbook.io/claimr-help-center'
                        target='_blank'
                        rel='noreferrer'
                    >
                        Read docs
                    </a>
                    <a href='https://claimr.io/terms-and-conditions' target='_blank' rel='noreferrer'>
                        Terms and Conditions
                    </a>
                    <a href='https://claimr.io/privacy-policy' target='_blank' rel='noreferrer'>
                        Privacy Policy
                    </a>
                </menu>
            </div>
            <div className='label'>Widget container</div>
            <ClaimrWidgetComponent />
            <div className='flex-spacer' />{' '}
            <footer>
                <div className='copyright'>
                    Powered by{' '}
                    <a href='https://claimr.io' target='_blank' rel='noreferrer'>
                        {' '}
                        ⚡ claimr.io™
                    </a>
                </div>
            </footer>
        </div>
    );
};

export default ExampleApp;
